import { Sparkles } from "lucide-react";

const items = [
  "React", "React Native", "FastAPI", "MongoDB", "UI/UX Tasarım",
  "Zamanında Teslim", "Ölçeklenebilir Mimari", "Temiz Kod", "SEO Uyumlu", "7/24 Destek",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee-container"
    className="border-y border-white/[0.06] bg-[#0F0E17] py-5 overflow-hidden"
  >
    <div className="marquee-track">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-3 px-8 shrink-0">
          <Sparkles size={13} className="text-[#F59E0B]" />
          <span className="font-code text-sm text-[#9CA3AF] whitespace-nowrap tracking-wide">
            {item}
          </span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
